import React from 'react'
import { Alert, Progress, Typography, Space } from 'antd'
import { TVariantMode } from 'models/app'
import { EProductType } from 'models/product'

interface IProductRatingProps {
  mode: TVariantMode
  ratingScore?: number
  productType?: EProductType
}

export const ProductRating: React.FC<IProductRatingProps> = ({
  mode,
  ratingScore,
  productType
}) => {
  const isCreateMode = mode === 'create'

  // Показываем рейтинг только для основных товаров, не для вариаций
  if (productType === EProductType.VARIATION) {
    return null
  }

  const getRatingColor = (score: number) => {
    if (score >= 80) return '#52c41a'
    if (score >= 60) return '#faad14'
    if (score >= 40) return '#fa8c16'
    return '#ff4d4f'
  }

  const getRatingText = (score: number) => {
    if (score >= 80) return 'Отличный рейтинг'
    if (score >= 60) return 'Хороший рейтинг'
    if (score >= 40) return 'Средний рейтинг'
    return 'Низкий рейтинг'
  }

  const recommendations = [
    'Фото — до 20 баллов (оптимум ≥5 фото)',
    'Описание — до 20 баллов (лучше 800–1200 символов)',
    'Характеристики — до 55 баллов (главный фактор, счёт идёт по проценту заполненности; при малом числе характеристик часть баллов обрезается, рекомендуемое число - 5)',
    'Вариации — до 5 баллов (небольшой бонус за размеры и цвета)'
  ]

  return (
    <Alert
      type='info'
      message={
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, justifyContent: 'space-between' }}>
            <Typography.Title level={5} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
              Как считается рейтинг
            </Typography.Title>
            {!isCreateMode && ratingScore !== undefined && (
              <Space align='center'>
                <Progress
                  type='circle'
                  percent={ratingScore}
                  size={60}
                  strokeColor={getRatingColor(ratingScore)}
                  format={(percent) => `${percent}`}
                />
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>
                    {getRatingText(ratingScore)}
                  </div>
                  <div style={{ fontSize: 13, color: '#8c8c8c' }}>
                    {ratingScore} из 100 баллов
                  </div>
                </div>
              </Space>
            )}
          </div>
          <div style={{ marginBottom: 8 }}>
            {recommendations.map((item, index) => (
              <div key={index} style={{ fontSize: 14, marginBottom: 4, lineHeight: 1.4 }}>
                {item}
              </div>
            ))}
          </div>
          <div style={{ fontSize: 13, color: '#595959', fontStyle: 'italic' }}>
            Чем выше рейтинг, тем более полная и привлекательная карточка для покупателей и алгоритмов маркетплейса.
          </div>
        </div>
      }
      style={{ marginBottom: 30 }}
    />
  )
}